export default {"src":"/_next/static/media/room-category-oceafront-active.758014d8.svg","height":48,"width":73};